export const CONSENT_VERSION = 1;
export const CONSENT_KEY_PREFIX = 'webinarplus.cookieConsent.';
export const DEFAULT_PREFERENCES = Object.freeze({ necessary: true, externalContent: false, diagnostics: false });

export function readConsent(scope) {
  try {
    const record = JSON.parse(localStorage.getItem(CONSENT_KEY_PREFIX + scope));
    if (!record || record.version !== CONSENT_VERSION || record.scope !== scope ||
        !Number.isFinite(record.updatedAt) || !Number.isFinite(record.expiresAt) ||
        record.expiresAt <= Date.now() || record.expiresAt <= record.updatedAt ||
        typeof record.preferences?.externalContent !== 'boolean' ||
        typeof record.preferences?.diagnostics !== 'boolean') return null;
    return { ...record, preferences: { ...record.preferences, necessary: true }, persisted: true };
  } catch {
    return null;
  }
}

export function saveConsent(scope, preferences) {
  const now = new Date();
  const expires = new Date(now);
  expires.setUTCMonth(expires.getUTCMonth() + 6);
  const record = {
    version: CONSENT_VERSION, scope, updatedAt: now.getTime(), expiresAt: expires.getTime(),
    preferences: {
      necessary: true,
      externalContent: preferences?.externalContent === true,
      diagnostics: preferences?.diagnostics === true,
    },
  };
  try {
    localStorage.setItem(CONSENT_KEY_PREFIX + scope, JSON.stringify(record));
    return { ...record, persisted: true };
  } catch {
    return { ...record, persisted: false };
  }
}
